/*
How to use - *title* as a direct option in a vue component

1. export default { title : 'Some Title'}

2. export default { title () { return `${this.dataProperty}`}}
*/
const getTitle = (vm) => {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function' ? title.call(vm) : title
  }
}
export default {
  created() {
    const title = getTitle(this)
    if (title) {
      document.title = `${title} | Buyer Portal`
    }
  }
}
